/*globals window, $, mobileMenuSize, isMobile */

var SUBMENU = {

    mainMenu: undefined,
    subMenu: undefined,
    subMenuTop: undefined,
    
    init: function () {
        "use strict";
        
        this.mainMenu = $("#menu");
        this.subMenu = $("#subMenu");
        this.setPos();
    },

    pin: function () {
        "use strict";

        this.init();

        // 24 is top offset of pseudo button element
        var scrollTop = $(window).scrollTop() + this.mainMenu.outerHeight() - 24 ;

        if (scrollTop >= this.subMenuTop) {
            $(".content").addClass("submenuFixed");
        } else {
            $(".content").removeClass("submenuFixed");
        }
    },

    setPos: function () {
        "use strict";

        if (this.subMenu.exists() && this.subMenuTop === undefined) {
            this.subMenuTop = this.subMenu.offset().top;
        }
    }
};

$(document).ready(function () {
    "use strict";

    SUBMENU.init();
});

$(window).resize(function () {
    "use strict";

    if ($(window).width() > mobileMenuSize) {
        SUBMENU.pin();
    }
});

$(document).scroll(function () {
    "use strict";

    if ($(window).width() > mobileMenuSize) {
        SUBMENU.pin();
    }
});